module.exports = __webpack_public_path__ + "static/media/smm-circle.52c34949.svg";